
import Vue, { PropType } from 'vue';

type AlertType = 'error' | 'warning' | 'info' | 'success';

export default Vue.extend({
    name: 'Alert',
    props: {
        type: {
            type: String as PropType<AlertType>,
            default: 'info',
        },
    },
    computed: {
        typeClass(): string {
            switch (this.type) {
                case 'error':
                    return 'color-red';
                case 'warning':
                    return 'color-yellow';
                case 'success':
                    return 'color-green';
                case 'info':
                default:
                    return 'color-blue';
            }
        },
        typeIcon(): string {
            switch (this.type) {
                case 'error':
                    return 'exclamation-circle';
                case 'warning':
                    return 'exclamation-triangle';
                case 'success':
                    return 'check-circle';
                case 'info':
                default:
                    return 'circle-info';
            }
        },
        hasBottomSlot(): boolean {
            return !!this.$slots.bottom;
        },
    },
});
